import css from "./parcelsmap.scss?inline";
import mapcss from "./../../utils/maps/maps.scss?inline";
import globalStyles from "../../index.scss?inline";
import { Component } from "../../utils/Component";
import { ArgSpecDictionary } from "../component-utils";
import { OverlayHelper } from "./OverlayHelper";
import { mapHelper } from "../../utils/maps/map-helper";
import { Parcel } from "./Parcel";
import { createSVGOverlay } from "../LotMap/SVGOverlay";

const DEBUG_VERBOSE: boolean = false;
const CLASS_NAME: string = "HHDSParcelsMap";
export const HHDSParcelsMapTagName: string = "hhds-parcelsmap";
const TAG_NAME: string = HHDSParcelsMapTagName;

const OVERLAY_URL = "/wp-content/themes/hhh-teravalis/assets/images/amenities.svg";
const AMENITY_LAYER_URL = "/wp-content/themes/hhh-teravalis/data/hh-parcel-amenities.json";
const PARKS_LAYER_URL = "/wp-content/themes/hhh-teravalis/data/hh-parcel-parks.json";
const MAP_CENTERING_WIDTH: number = 1024;
export const HHDSParcelsMapAttrNames = {
  key: "key",
  image: "image",
};

export enum HHDSParcelsMapEvent {
  pan = "hhds-parcelsmap-pan",
  parcelActivated = "hhds-parcelsmap-parcel-activated",
}

/*interface ZoomSettings {
  zoom: number;
  minZoom: number;
  maxZoom: number;
}*/

const Attrs = HHDSParcelsMapAttrNames;

export class HHDSParcelsMap extends Component {
  private overlayImage: string = OVERLAY_URL;
  //private panBoundsPerBreakpoint: { [key: string]: google.maps.LatLngBounds } = {};
  //private zoomPerBreakpoint: { [key: string]: ZoomSettings } = {};
  private map: any;
  private parcels: { [id: string]: Parcel } = {};
  private amenityLayer!: google.maps.Data;
  private parksLayer!: google.maps.Data;
  private defaultBounds: google.maps.LatLngBounds | null = null;
  private debugOverlay: google.maps.Rectangle | null = null;

  constructor() {
    super();
  }

  getParcel(id: string): Parcel | null {
    return this.parcels[id] || null;
  }

  protected override init(): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "init");

    this.shadow.innerHTML = `
      <style>${globalStyles}</style>
			<style>${css}</style>
      <style>${mapcss}</style>
			<div class="${TAG_NAME}">
          <div class="hhds-parcelsmap-container"></div>
      </div>
		`;

    if (this.vars.get<string>(Attrs.image)) {
      this.overlayImage = this.vars.get<string>(Attrs.image);
    }

    // this.overlayImage = this.shadow.querySelector(".hhds-parcelsmap-overlay") as HTMLElement;
    // if (this.overlayImage) this.overlayImage.style.visibility = "hidden";
    this.initGoogleMaps();

    /*document.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.key === "Tab") console.log("Focused:", this.shadowRoot?.activeElement);
    });*/

    this.observeBreakpointChanges((breakpoint: string | null) => this.updateForBreakpoint(breakpoint));
    this.updateForBreakpoint(this.currentBreakpoint);
  }

  async initGoogleMaps() {
    const container = this.shadow.querySelector(".hhds-parcelsmap-container") as HTMLElement;

    // Initial map creation ////////////////////////////////////////////////

    this.map = await mapHelper.createMap({
      apiKey: this.vars.get<string>("key"),
      mapId: "7b0c8903a11fc8907ae0c081",
      center: { lat: 33.59018486269875, lng: -113.71496494971892 },
      zoom: 16, //16.3
      minZoom: 16, //15
      maxZoom: 18, //17
      //zoomControl: this.currentBreakpoint === "xs",
      container: container,
    });

    OverlayHelper.defineTypes();

    // Load data to form map features //////////////////////////////////////

    const geoJson = await this.fetchDataAndCreateGeoJson();
    this.map.data.addGeoJson(geoJson);

    // Event listeners /////////////////////////////////////////////////////

    this.map.addListener("bounds_changed", () => this.emitEvent(HHDSParcelsMapEvent.pan));

    /*this.map.addListener("zoom_changed", () => {
      const zoom = this.map.getZoom();
      console.log('Zoom changed:', zoom);
    });*/

    window.addEventListener("resize", () => {
      if (this.map) {
        this.updateBounds();
        google.maps.event.trigger(this.map, "resize");
      }
    });

    this.addFeatureInteractionEvents();

    // Other map setup ////////////////////////////////////////////////////

    this.setupMapStyle();

    // Create parcel-per-feature objects //////////////////////////////////

    await this.createParcelObjects();

    // Sort parcel tabIndices by their XY position ////////////////////////
    const sortedParcels = Object.values(this.parcels);
    sortedParcels.sort((a, b) => {
      const aSortValue: number = a.feature.getProperty("sortValue") as number;
      const bSortValue: number = b.feature.getProperty("sortValue") as number;
      return aSortValue - bSortValue;
    });
    sortedParcels.forEach((parcel, index) => {
      if (parcel.interactiveElement) parcel.interactiveElement.tabIndex = index + 1;
    });

    // Setup whole-map overlay if required ////////////////////////////////
    this.defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(33.59173981141882, -112.71925540675291),
      new google.maps.LatLng(33.60823808684144, -112.68595794096298)
    );

    if (this.vars.get<string>("image")) {
      this.overlayImage = this.vars.get<string>("image");
    }

    await createSVGOverlay(this.overlayImage, this.defaultBounds, this.map);

    // const bounds = mapHelper.getPaddedBounds(this.map.data);
    this.updateBounds();

    await this.loadAmenityLayer();
    await this.loadParksLayer();

    setTimeout(() => {
      this.updateBounds();
    }, 350);

    // Optionally remove tabbability from Google Maps elements
    /*const observer = new MutationObserver(() => {
      const links = this.map.getDiv().querySelectorAll("a[href], [tabindex], button");
      links.forEach((link: any) => {
        // ensure that the link isn't an 'object' element
        if (link.tagName.toLowerCase() === "object") return;
        link.setAttribute("tabindex", "-1");
        link.setAttribute("aria-hidden", "true");
      });
    });
    observer.observe(this.map.getDiv(), { childList: true, subtree: true });*/

    // this.amenityLayer = new google.maps.Data();
    // this.amenityLayer.loadGeoJson(AMENITY_LAYER_URL, null, () => {
    //   this.amenityLayer.setStyle(() => {
    //     return {
    //       strokeWeight: 0,
    //       fillColor: "#9BBBB4",
    //       fillOpacity: 1,
    //     };
    //   });

    //   this.amenityLayer.setMap(this.map);

    //   this.parksLayer = new google.maps.Data();
    //   this.parksLayer.loadGeoJson(PARKS_LAYER_URL, null, () => {
    //     this.parksLayer.setStyle(() => {
    //       return {
    //         strokeWeight: 0,
    //         fillColor: "#79A365",
    //         fillOpacity: 1,
    //       };
    //     });

    //     this.parksLayer.setMap(this.map);

    //     setTimeout(() => {
    //       this.updateBounds();
    //     }, 250);

    //   });

    // });

    // Select a random feature
    //const parcels = Object.values(this.parcels);
    //const parcel = parcels[0];
    //if (parcel) this.emitEvent(HHDSParcelsMapEvent.parcelActivated, { id: parcel.id });
  }

  private loadAmenityLayer(): Promise<void> {
    return new Promise((resolve) => {
      this.amenityLayer = new google.maps.Data();
      this.amenityLayer.loadGeoJson(AMENITY_LAYER_URL, null, () => {
        this.amenityLayer.setStyle(() => ({
          strokeWeight: 0,
          fillColor: "#9BBBB4",
          fillOpacity: 1,
        }));
        this.amenityLayer.setMap(this.map);
        this.updateBounds();
        resolve();
      });
    });
  }

  private loadParksLayer(): Promise<void> {
    return new Promise((resolve) => {
      this.parksLayer = new google.maps.Data();
      this.parksLayer.loadGeoJson(PARKS_LAYER_URL, null, () => {
        this.parksLayer.setStyle(() => ({
          strokeWeight: 0,
          fillColor: "#79A365",
          fillOpacity: 1,
        }));
        this.parksLayer.setMap(this.map);
        this.updateBounds();
        resolve();
      });
    });
  }

  private updateBounds() {
    // This is a bit of a fudge to ensure the map bounds take SOME of the svg overlay into account
    // when centering the map.

    let bounds = mapHelper.getPaddedBounds(this.map.data);
    if (window.innerWidth > MAP_CENTERING_WIDTH) {
      const sw = bounds?.getSouthWest();
      const ne = bounds?.getNorthEast();
      if (ne && sw) {
        const width = ne.lng() - sw.lng();
        const offset = width * 0.35;
        const expandedNe = new google.maps.LatLng(ne.lat(), ne.lng() + offset);
        bounds = new google.maps.LatLngBounds(sw, expandedNe);
      }
    }

    this.map.fitBounds(bounds, 12);
    this.map.setOptions({
      restriction: { latLngBounds: bounds, strictBounds: false },
    });

    if (this.debugOverlay) this.debugOverlay.setVisible(false);

    if (DEBUG_VERBOSE)
      this.debugOverlay = new google.maps.Rectangle({
        bounds,
        map: this.map,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.1,
      });
  }

  private async createParcelObjects(): Promise<void> {
    const promises: Promise<void>[] = [];
    this.map.data.forEach((feature: any) => {
      const parcelId: string = feature.getProperty("parcelId");
      const promise = Parcel.create(feature, this.map).then((parcel) => {
        this.parcels[parcelId] = parcel;

        const position = mapHelper.getFeaturePosition(feature);
        if (position) {
          const pixelPosition = this.map.getProjection().fromLatLngToPoint(position);
          const sortValue = pixelPosition.x + pixelPosition.y * 1000000;
          feature.setProperty("sortValue", sortValue);
        }

        if (parcel.interactiveElement) {
          parcel.interactiveElement.dataset.parcelId = parcelId;
        }

        parcel.interactiveElement?.addEventListener("keydown", (event: KeyboardEvent) => {
          if (event.key === "Enter") {
            this.activateParcelForFeature(feature, true);
            event.preventDefault();
          }
        });
      });
      promises.push(promise);
    });
    await Promise.all(promises);
  }

  private async fetchDataAndCreateGeoJson(): Promise<any> {
    const parcelsApiUrl: string = `/wp-json/teravalis/v1/parcels`;
    const response = await fetch(parcelsApiUrl);
    if (!response.ok) throw new Error(response.statusText);
    const parcelsData = await response.json();
    const featureJsons = parcelsData.map((cmsItem: any) => this.constructFeatureJson(cmsItem));
    const geoJson = { type: "FeatureCollection", features: featureJsons };
    return geoJson;
  }

  private constructFeatureJson(cmsItem: any): any {
    let logoJson: any;
    //if (item.builder.logo) logoJson = { url: item.builder.logo.url, width: item.builder.logo.width, height: item.builder.logo.height };
    if (cmsItem.logo) {
      logoJson = {
        url: cmsItem.logo,
        scale: cmsItem.logo_scale,
        x: cmsItem.logo_x,
        y: cmsItem.logo_y,
      };
    }
    const featureJson = {
      type: "Feature",
      properties: {
        title: cmsItem.title,
        logo: logoJson,
        parcelId: cmsItem.ID,
        builderId: cmsItem.builder?.ID,
        collections: cmsItem.collections,
      },
      geometry: cmsItem.geometry_json ?? {},
    };
    return featureJson;
  }

  private setupMapStyle(): void {
    this.map.data.setStyle((feature: any) => {
      return {
        fillColor: "#e2e2e2",
        fillOpacity: 1.0,
        strokeColor: "#cccccc",
        strokeWeight: this.getStrokeWeight(),
        cursor: this.isFeatureInteractive(feature) ? "pointer" : "default",
      };
    });
  }

  private getStrokeWeight(): number {
    //const zoom = this.map.getZoom();
    //return zoom > 17 ? 0.8 : 0;
    return 0.8;
  }

  private isFeatureInteractive(feature: any): boolean {
    const parcelId = feature.getProperty("parcelId");
    if (!parcelId) {
      return false;
    }
    const parcel = this.parcels[parcelId];
    return parcel?.interactive || false;
  }

  private addFeatureInteractionEvents() {
    this.map.data.addListener("click", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        this.activateParcelForFeature(event.feature, false);
      }
    });

    this.map.data.addListener("mouseover", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        const parcelId = event.feature.getProperty("parcelId");
        this.parcels[parcelId]?.handleMouseOver();
      }
    });
    this.map.data.addListener("mouseout", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        const parcelId = event.feature.getProperty("parcelId");
        this.parcels[parcelId]?.handleMouseOut();
      }
    });

    this.map.data.addListener("focus", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        const parcelId = event.feature.getProperty("parcelId");
        this.parcels[parcelId]?.handleFocused();
      }
    });
    this.map.data.addListener("blur", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        const parcelId = event.feature.getProperty("parcelId");
        this.parcels[parcelId]?.handleUnfocused();
      }
    });

    // TODO: Check if this is the correct way to handle google map feature keypress
    this.map.data.addListener("keydown", (event: any) => {
      if (this.isFeatureInteractive(event.feature)) {
        if (event.key === "Enter") {
          this.activateParcelForFeature(event.feature, true);
        }
      }
    });
  }

  private updateForBreakpoint(breakpoint: string | null = null) {
    if (!breakpoint) return;
    //this.map?.setOptions({ zoomControl: breakpoint == "xs" });
  }

  rehighlightParcelIfRequired(parcelId: string) {
    const parcel = this.parcels[parcelId];
    if (parcel.selectedViaKeyboard) parcel.highlighted = true;
  }

  unactivateParcels(exceptId: string | null = null): void {
    Object.values(this.parcels).forEach((parcel: Parcel) => {
      const parcelId = parcel.feature.getProperty("parcelId");
      if (exceptId != parcelId) parcel.unactivate();
    });
  }

  private activateParcelForFeature(feature: any, viaKeyboard: boolean): void {
    const parcelId = feature.getProperty("parcelId");
    const parcel = this.parcels[parcelId];
    parcel.setAsActivated({ viaKeyboard: viaKeyboard });
    this.unactivateParcels(parcelId);
    this.emitEvent(HHDSParcelsMapEvent.parcelActivated, {
      id: parcelId,
      element: parcel.interactiveElement,
    });
  }

  protected override destroy(): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "destroy");
  }

  override onAttributeChanged(name: string, _oldValue: string, newValue: string): void {
    DEBUG_VERBOSE && console.log(CLASS_NAME, "Attribute changed: ", name, _oldValue, newValue);
    this.reinit();
  }

  override onSlotChange(_slot: HTMLSlotElement, _elements: Element[]): void {}

  static override argSpecs(): ArgSpecDictionary {
    return ArgSpecs;
  }
}

export const ArgSpecs: ArgSpecDictionary = {
  [Attrs.key]: {
    description: "Google Maps API key.",
    defaultValue: "",
    type: String,
  },
  [Attrs.image]: {
    description: "Overlay image url.",
    defaultValue: "",
    type: String,
  },
};
